import { jsxs, jsx, Fragment as Fragment$1 } from 'react/jsx-runtime';
import { themedColor, font, Flex, Box } from '@lemonade-hq/cdk';
import { DEFAULT_REGION, DEFAULT_LANGUAGE, US_REGION } from '@lemonade-hq/lemonation';
import { Accordion, AccordionSummary, MEDIA_QUERIES, AccordionDetails } from '@lemonade-hq/nuis';
import { useState, useCallback, Fragment, useEffect } from 'react';
import styled from 'styled-components';
import { useAnalyticsContext } from '../../../providers/AnalyticsProvider.esm.js';
import { useCommonI18nContext } from '../../../providers/I18nProvider.esm.js';
import { useNavContext } from '../../../providers/NavProvider.esm.js';
import { SectionTitle } from './shared.esm.js';
import { useComplianceProvider } from '../../../providers/ComplianceProvider.esm.js';

/* eslint-disable react/no-array-index-key */ function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  color: ",
        ";\n  font-size: 1.4rem;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  background-color: ",
        ";\n  border: none;\n  border-radius: 8px;\n  box-shadow: none;\n  padding: 0 20px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  ",
        ";\n  color: ",
        ";\n  text-transform: uppercase;\n\n  span svg path {\n    stroke: ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n    width: 50%;\n    padding-left: 16px;\n    min-height: 150px;\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n    width: 25%;\n    padding-left: 16px;\n    min-height: 150px;\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  width: 100%;\n  height: auto;\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n    padding: 0 0 20px 0;\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        "\n  list-style: none;\n  padding: 0 0 20px 6px;\n  ",
        ";\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _tagged_template_literal([
        "\n  -webkit-tap-highlight-color: transparent;\n  align-items: center;\n  margin-top: 16px;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _tagged_template_literal([
        "\n  color: ",
        ";\n  ",
        ";\n  text-decoration: none;\n\n  &:hover {\n    text-decoration: underline;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _tagged_template_literal([
        "\n  border: none;\n  background: transparent;\n  padding: 0;\n  margin: 0;\n  cursor: pointer;\n  color: ",
        ";\n  ",
        ";\n  text-decoration: none;\n  text-align: left;\n\n  &:hover {\n    text-decoration: underline;\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
var StyledSectionTitle = styled(SectionTitle)(_templateObject(), themedColor("white"));
var StyledAccordion = styled(Accordion)(_templateObject1(), function(props) {
    return props.theme.colors.darkMineShaft;
});
var StyledAccordionSummary = styled(AccordionSummary)(_templateObject2(), font("main", {
    fontSize: "1.4rem",
    fontWeight: 700
}), themedColor("white"), themedColor("white"));
var ListItemWrapper = function(param) {
    var children = param.children, item = param.item, product = param.product;
    if (!item.includes("_explained") || item.includes(product)) return /*#__PURE__*/ jsxs(Fragment$1, {
        children: [
            " ",
            children
        ]
    });
    return null;
};
var LinkListContainer = styled(Flex)(_templateObject5(), MEDIA_QUERIES.tablet(_templateObject3()), MEDIA_QUERIES.desktop(_templateObject4()));
var LinksList = styled.ul(_templateObject7(), MEDIA_QUERIES.tabletAndDesktop(_templateObject6()));
var ListItem = styled(Flex)(_templateObject8());
var ItemLink = styled.a(_templateObject9(), themedColor("metal"), font("main", {
    fontSize: "1.6rem",
    lineHeight: "2.1rem"
}));
var ButtonAsItemLink = styled.button.attrs({
    type: "button"
})(_templateObject10(), themedColor("metal"), font("main", {
    fontSize: "1.6rem",
    lineHeight: "1.6rem"
}));
var isManageCookiesItem = function(item) {
    return item === "manage_cookies";
};
var isDoNotShareMyPersonalInformation = function(item) {
    return item === "do_not_share_my_personal_information";
};
var useRenderCookieRelatedItem = function() {
    var _useComplianceProvider = useComplianceProvider(), setShowConsentBanner = _useComplianceProvider.setShowConsentBanner, setIsPersonalInfoView = _useComplianceProvider.setIsPersonalInfoView;
    var _useAnalyticsContext = useAnalyticsContext(), canManageCookies = _useAnalyticsContext.canManageCookies, trackEvent = _useAnalyticsContext.trackEvent;
    var isCCPA = useComplianceProvider().isCCPA;
    var renderCookiesRelatedItem = useCallback(function(item) {
        return (!isManageCookiesItem(item) || canManageCookies) && (isCCPA || !isDoNotShareMyPersonalInformation(item));
    }, [
        canManageCookies,
        isCCPA
    ]);
    var isCookieRelatedItem = useCallback(function(item) {
        return isManageCookiesItem(item) || isDoNotShareMyPersonalInformation(item);
    }, []);
    var onManageCookiesClick = useCallback(function(isPersonalInfoView) {
        setIsPersonalInfoView(isPersonalInfoView);
        setShowConsentBanner(true);
        trackEvent(isPersonalInfoView ? "cookie_consent.click_manage_personal_info" : "cookie_consent.click_manage_cookies");
    }, [
        setShowConsentBanner,
        trackEvent,
        setIsPersonalInfoView
    ]);
    return {
        renderCookiesRelatedItem: renderCookiesRelatedItem,
        isCookieRelatedItem: isCookieRelatedItem,
        onManageCookiesClick: onManageCookiesClick
    };
};
var LinksListContainer = function(param) {
    var section = param.section, items = param.items, product = param.product;
    var t = useCommonI18nContext().t;
    var nav = useNavContext().nav;
    var _useRenderCookieRelatedItem = useRenderCookieRelatedItem(), renderCookiesRelatedItem = _useRenderCookieRelatedItem.renderCookiesRelatedItem, isCookieRelatedItem = _useRenderCookieRelatedItem.isCookieRelatedItem, onManageCookiesClick = _useRenderCookieRelatedItem.onManageCookiesClick;
    var _useState = _sliced_to_array(useState(false), 2), isClient = _useState[0], setIsClient = _useState[1];
    useEffect(function() {
        setIsClient(true);
    }, []);
    return /*#__PURE__*/ jsx(LinksList, {
        "aria-labelledby": "".concat(section, "_label"),
        children: items.map(function(item) {
            return /*#__PURE__*/ jsx(ListItemWrapper, {
                item: item,
                product: product,
                children: isCookieRelatedItem(item) ? /*#__PURE__*/ jsx(ListItem, {
                    as: "li",
                    style: {
                        display: renderCookiesRelatedItem(item) && isClient ? "flex" : "none"
                    },
                    children: /*#__PURE__*/ jsx(ButtonAsItemLink, {
                        "data-event": "footer_".concat(item, "_clicked"),
                        onClick: function() {
                            return onManageCookiesClick(item === "do_not_share_my_personal_information");
                        },
                        children: t("nav.".concat(item, ".title"))
                    })
                }, item) : /*#__PURE__*/ jsx(ListItem, {
                    as: "li",
                    children: /*#__PURE__*/ jsx(ItemLink, {
                        "data-event": "footer_".concat(item, "_clicked"),
                        href: nav[item],
                        children: t("nav.".concat(item, ".title"))
                    })
                }, item)
            }, item);
        })
    });
};
var INSURANCE_PRODUCTS = [
    "homeowners",
    "renters",
    "pet",
    "car",
    "life"
];
var FooterContentLinks = function(param) {
    var links = param.links, product = param.product;
    var _useCommonI18nContext = useCommonI18nContext(), region = _useCommonI18nContext.region, lang = _useCommonI18nContext.lang, t = _useCommonI18nContext.t;
    var _useState = _sliced_to_array(useState(undefined), 2), accordionOpenId = _useState[0], setAccordionOpenId = _useState[1];
    var handleAccordionToggle = useCallback(function(id) {
        return function(isOpen) {
            if (isOpen) {
                setAccordionOpenId(id);
            } else {
                setAccordionOpenId(undefined);
            }
        };
    }, []);
    var _links_region_lang;
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    var footerNav = (_links_region_lang = links[region][lang]) !== null && _links_region_lang !== void 0 ? _links_region_lang : links[DEFAULT_REGION][DEFAULT_LANGUAGE];
    var showGroupedProductsAccordionTab = region === US_REGION || lang === "fr";
    return /*#__PURE__*/ jsxs(Flex, {
        flexWrap: "wrap",
        justifyContent: "flex-start",
        mt: [
            "0px",
            "-20px"
        ],
        width: [
            1,
            1,
            1
        ],
        children: [
            showGroupedProductsAccordionTab && /*#__PURE__*/ jsx(Box, {
                display: [
                    "block",
                    "none"
                ],
                mb: "6px",
                mt: "0px",
                width: "100%",
                children: /*#__PURE__*/ jsxs(StyledAccordion, {
                    onToggle: handleAccordionToggle("Products"),
                    openedByDefault: accordionOpenId === "Products",
                    children: [
                        /*#__PURE__*/ jsxs(StyledAccordionSummary, {
                            children: [
                                " ",
                                t("footer.titles.products")
                            ]
                        }),
                        /*#__PURE__*/ jsx(AccordionDetails, {
                            children: footerNav.map(function(navColumn, index) {
                                return /*#__PURE__*/ jsx(Fragment, {
                                    children: Object.keys(navColumn).map(function(section, sectionIdx) {
                                        var items = navColumn[section];
                                        var isInsuranceMenu = INSURANCE_PRODUCTS.includes(section);
                                        if (items == null || !isInsuranceMenu) return null;
                                        return /*#__PURE__*/ jsxs(Fragment, {
                                            children: [
                                                /*#__PURE__*/ jsx(Box, {
                                                    mb: "20px",
                                                    ml: "6px",
                                                    mt: "16px",
                                                    children: /*#__PURE__*/ jsx(StyledSectionTitle, {
                                                        id: "".concat(section, "_label_mobile"),
                                                        children: t("footer.titles.".concat(section))
                                                    })
                                                }),
                                                /*#__PURE__*/ jsx(LinksListContainer, {
                                                    items: items,
                                                    product: product,
                                                    section: section
                                                })
                                            ]
                                        }, sectionIdx);
                                    })
                                }, index);
                            })
                        })
                    ]
                })
            }),
            footerNav.map(function(navColumn, index) {
                return /*#__PURE__*/ jsx(Fragment, {
                    children: /*#__PURE__*/ jsx(LinkListContainer, {
                        flexDirection: "column",
                        mt: [
                            "0px",
                            "20px"
                        ],
                        pb: [
                            "0px",
                            "20px",
                            "0px"
                        ],
                        children: Object.keys(navColumn).map(function(section, sectionIdx) {
                            var items = navColumn[section];
                            var isInsuranceMenu = INSURANCE_PRODUCTS.includes(section);
                            if (items == null) return null;
                            return /*#__PURE__*/ jsxs(Fragment, {
                                children: [
                                    /*#__PURE__*/ jsxs(Box, {
                                        display: [
                                            "none",
                                            "block"
                                        ],
                                        children: [
                                            /*#__PURE__*/ jsx(Box, {
                                                mb: "20px",
                                                mt: "15px",
                                                children: /*#__PURE__*/ jsx(StyledSectionTitle, {
                                                    id: "".concat(section, "_label_desktop"),
                                                    children: t("footer.titles.".concat(section))
                                                })
                                            }),
                                            /*#__PURE__*/ jsx(LinksListContainer, {
                                                items: items,
                                                product: product,
                                                section: section
                                            })
                                        ]
                                    }),
                                    isInsuranceMenu ? null : /*#__PURE__*/ jsx(Box, {
                                        display: [
                                            "block",
                                            "none"
                                        ],
                                        my: "6px",
                                        children: /*#__PURE__*/ jsxs(StyledAccordion, {
                                            id: "".concat(section, "_accordion"),
                                            onToggle: handleAccordionToggle(section),
                                            openedByDefault: accordionOpenId === section,
                                            children: [
                                                /*#__PURE__*/ jsx(StyledAccordionSummary, {
                                                    children: t("footer.titles.".concat(section))
                                                }),
                                                /*#__PURE__*/ jsx(AccordionDetails, {
                                                    children: /*#__PURE__*/ jsx(LinksListContainer, {
                                                        items: items,
                                                        product: product,
                                                        section: section
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }, sectionIdx);
                        })
                    })
                }, index);
            })
        ]
    });
};

export { FooterContentLinks, useRenderCookieRelatedItem };
